import * as kundeRest from './kunde-rest';

window['SVV.dinside.felles.kundeRestV2'] =
	window['SVV.dinside.felles.kundeRestV2'] || {};
window['SVV.dinside.felles.kundeRestV2'].hentMeg =
	window['SVV.dinside.felles.kundeRestV2'].hentMeg || {};

export function hentMeg(): Promise<kundeRest.Kunde> {
	if (!window['SVV.dinside.felles.kundeRestV2'].hentMeg.promise) {
		window['SVV.dinside.felles.kundeRestV2'].hentMeg.promise = kundeRest
			.hentMeg()
			.then(res => {
				return res.json();
			});
		return window['SVV.dinside.felles.kundeRestV2'].hentMeg.promise;
	}
	return window['SVV.dinside.felles.kundeRestV2'].hentMeg.promise;
}
